import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { FaTachometerAlt, FaFileAlt, FaCar, FaSignOutAlt, FaBullhorn, FaPoll, FaTabletAlt, FaUsers, FaRss, FaClipboardCheck, FaHeadset, FaUserShield, FaCommentDots } from 'react-icons/fa';
import { auth } from './firebase'; // Import auth
import { signOut } from "firebase/auth"; // Import signOut

// The Layout component wraps the authenticated part of your app
function Layout() {
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut(auth).then(() => {
      // Sign-out successful.
      navigate('/login');
    }).catch((error) => {
      // An error happened.
      console.error("Sign out error", error);
    });
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <h1 className="sidebar-header">
          <FaCar />
          Drivio Admin
        </h1>
        <nav className="sidebar-nav">
          <NavLink to="/" end>
            <FaTachometerAlt />
            Fleet Dashboard
          </NavLink>
          <NavLink to="/applications">
            <FaFileAlt />
            Applications
          </NavLink>
          <NavLink to="/inquiries">
  <FaBullhorn />
  Inquiries
</NavLink>
<NavLink to="/survey-insights">
    <FaPoll />
    Survey Insights
  </NavLink>
  <NavLink to="/tablet-content"> {/* ✅ ADD THIS NAVLINK */}
  <FaTabletAlt />
  Tablet Content
</NavLink>
<NavLink to="/drivers"> {/* ✅ ADD THIS NAVLINK */}
  <FaUsers />
  Drivers
</NavLink>
<NavLink to="/points-review">
  <FaClipboardCheck />
  Points Review
</NavLink>
<NavLink to="/driver-central"> {/* ✅ ADD THIS NAVLINK */}
  <FaRss />
  Driver Central
</NavLink>
<NavLink to="/support-tickets">
    <FaHeadset />
    Support Tickets
  </NavLink>
  <NavLink to="/driver-support">
  <FaUserShield />
  Driver Tickets
</NavLink>
<NavLink to="/feedback">
  <FaCommentDots />
  Feedback
</NavLink>
        </nav>
        <div className="sidebar-footer">
            <button onClick={handleSignOut} className="btn btn-secondary" style={{width: '100%', justifyContent: 'center'}}>
                <FaSignOutAlt />
                Sign Out
            </button>
        </div>
      </aside>
      <main className="main-content">
        {/* The Outlet component renders the matched child route component */}
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
